<template>
    <div
        :class="{'_space-top' : spaceTop, '_space-bottom' : spaceBottom}"
        class="sme-table animate__parent"
    >
        <div

            class="sme-table__wrapper"
        >
            <div
                v-for="item in content"
                :key="item.title"
                class="sme-table__card"
            >
                <h3 class="sme-table__title" v-html="item.title"></h3>
                <p :class="{'_cut': item.action}" class="sme-table__subtitle" v-html="item.subtitle"></p>
                <div v-if="item.action" class="sme-table__action _desktop">
                    Акция <hint class="sme-table__action-hint" :text="item.action"/>
                </div>
                <div v-if="item.action" class="sme-table__action _mobile">
                    <a @click="$modal.show(item.more + '-action')" class="sme-table__action-button">Акция</a>
                </div>

                <div class="sme-table__factoid">
                    <p class="sme-table__factoid-title">Платежи ЮЛ</p>
                    <p class="sme-table__factoid-info" v-html="item.paysCompany"></p>
                </div>
                <div class="sme-table__factoid">
                    <p class="sme-table__factoid-title">Платежи ФЛ</p>
                    <p class="sme-table__factoid-info" v-html="item.paysPerson"></p>
                </div>
                <div class="sme-table__factoid _mobile-hidden">
                    <p class="sme-table__factoid-title">Интернет-банк</p>
                    <p class="sme-table__factoid-info" v-html="item.app"></p>
                </div>
                <div class="sme-table__factoid _mobile-hidden">
                    <p class="sme-table__factoid-title">Снятие наличных по чеку</p>
                    <p class="sme-table__factoid-info" v-html="item.cash"></p>
                </div>
                <div class="sme-table__factoid _mobile-hidden">
                    <p class="sme-table__factoid-title">Внесение наличных через кассу</p>
                    <p class="sme-table__factoid-info" v-html="item.refill"></p>
                </div>
                <div class="sme-table__factoid _mobile-hidden">
                    <p class="sme-table__factoid-title">Бизнес карты (cash in/cash out)</p>
                    <p class="sme-table__factoid-info" v-html="item.businessCard"></p>
                </div>
                <div class="_border _mv-32-24"></div>
                <div class="sme-table__terms" v-html="item.terms"></div>
                <div class="sme-table__bottom">
                    <a @click="$modal.show(item.more)" class="sme-table__buttons-more button button_gray-light">
                        Подробнее
                    </a>
                    <a v-if="!item.buttonAction" href="#sme-open-account" class="sme-table__buttons-action js-anchor button button_green">
                        Подать заявку
                    </a>
                    <a v-if="item.buttonAction" :href="item.buttonAction" class="sme-table__buttons-action button button_green">
                        Подать заявку
                    </a>
                </div>
            </div>
        </div>

        <d-modal
            v-cloak
            :name="item.more + '-action'"
            popup-title="Подробнее"
            size="footer"
            :disable-container="true"
            v-for="item in content"
            :key="item.subtitle"
        >
            <div class="sme-table__action-modal" v-html="item.action"></div>
        </d-modal>

        <d-modal
            v-cloak
            :name="item.more"
            :popup-title="item.title"
            size="full"
            :disable-container="true"
            v-for="item in content"
            :key="item.title"
        >
            <div class="sme-table__modal">
                <p class="sme-table__subtitle" v-html="item.subtitle"></p>
                <div v-if="item.action" class="sme-table__action">
                    Акция <hint class="sme-table__action-hint" :text="item.action"/>
                </div>
                <div class="sme-table__factoid">
                    <p class="sme-table__factoid-title">Платежи ЮЛ</p>
                    <p class="sme-table__factoid-info" v-html="item.paysCompany"></p>
                </div>
                <div class="sme-table__factoid">
                    <p class="sme-table__factoid-title">Платежи ФЛ</p>
                    <p class="sme-table__factoid-info" v-html="item.paysPerson"></p>
                </div>
                <div class="sme-table__factoid">
                    <p class="sme-table__factoid-title">Интернет-банк</p>
                    <p class="sme-table__factoid-info" v-html="item.app"></p>
                </div>
                <div class="sme-table__factoid">
                    <p class="sme-table__factoid-title">Снятие наличных по чеку</p>
                    <p class="sme-table__factoid-info" v-html="item.cash"></p>
                </div>
                <div class="sme-table__factoid">
                    <p class="sme-table__factoid-title">Внесение наличных через кассу</p>
                    <p class="sme-table__factoid-info" v-html="item.refill"></p>
                </div>
                <div class="sme-table__factoid">
                    <p class="sme-table__factoid-title">Бизнес карты (cash in/cash out)</p>
                    <p class="sme-table__factoid-info" v-html="item.businessCard"></p>
                </div>

                <div class="sme-table__bottom">
                    <div class="sme-table__terms" v-html="item.terms"></div>
                    <a @click="$modal.hide(item.more)" href="#sme-open-account" class="sme-table__buttons-action js-anchor button button_green">
                        Подать заявку
                    </a>
                </div>
            </div>
        </d-modal>
    </div>

</template>

<script>
export default {
    name: 'TableSme',
    props: {
        spaceTop: {
            type: Boolean,
            default: false,
        },
        spaceBottom: {
            type: Boolean,
            default: false,
        },
        content: {
            type: Array,
            default: () => {
                return []
            }
        }
    }
}
</script>
<style lang="scss">
@import '../../assets/scss/block/sme-table';
</style>
